import a from "./index398.js";
import { createElementBlock as o, openBlock as i, normalizeStyle as t, normalizeClass as d, createElementVNode as s } from "vue";
/* empty css         */
import n from "./index231.js";
const l = ["data-component", "data-mod"], m = ["id", "data-ad-unit-id"];
function r(e, p, c, u, f, b) {
  return i(), o("div", {
    "data-component": e.$options.name,
    "data-mod": e.placementId,
    class: d(["ms-adPlace", [
      `-${e.placementId}`,
      {
        "-sticky": e.isSticky,
        "-mobile": e.isMobile && !e.alwaysVisible,
        "-desktop": !e.isMobile && !e.alwaysVisible,
        "-disturber": e.isInDisturber
      }
    ]]),
    style: t({ "min-height": e.computedHeight })
  }, [
    s("div", {
      id: e.placementId,
      "data-ad-unit-id": e.computedHBId,
      class: "ms-adPlace__placement"
    }, null, 8, m)
  ], 14, l);
}
const k = /* @__PURE__ */ n(a, [["render", r], ["__scopeId", "data-v-7a86a1e5"]]);
export {
  k as default
};
